import { Breadcrumbs, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Admin_Parivartan_Get_All_Branches } from "../../../constants";
import RoBoTableComponent from "./components/RoBoTableComponent";
import axios from "axios";
import { Download } from "lucide-react";
import AddIcon from "@mui/icons-material/Add";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import RoBoModal from "./components/AddRoBoModal";
import BranchFilter from "./components/BranchFilter";

const RoBoComponent = ({}) => {
  const handleBack = () => {};
  const [roBoList, setRoBoList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [addRoBoModalOpen, setAddRoBoModalOpen] = useState(false);

  const [filters, setFilters] = useState({
    regionId: "",
    searchText: "",
    Zone: "",
  });

  const getRoBoData = async (filter) => {
    try {
      setLoading(true);
      const params = new URLSearchParams();

      if (filter.searchText) params.append("searchText", filter.searchText);
      if (filter.regionId) params.append("regionId", filter.regionId);

      const response = await axios.get(
        `${Admin_Parivartan_Get_All_Branches}?${params.toString()}`
      );
      const data = response.data.data || [];
      setRoBoList(data);
      return data;
    } catch (error) {
      console.error("Error fetching branches:", error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRoBoData(filters);
  }, []);

  const handleApplyFilter = () => {};

  const fetcRoBoData = async () => {
    try {
      const response = await axios.get(`${Admin_Parivartan_Get_All_Branches}`);
      const data = response.data.data || [];

      return data; // RETURN data for use in handleExport
    } catch (error) {
      console.error("Error fetching attendance data:", error);
      return null; // Return null or empty array on error
    }
  };

  const columns = [
    { headerName: "Branch ID", field: "BranchCode" },
    { headerName: "Branch Name", field: "Branch" },
    { headerName: "Region ID", field: "RegionId" },
    { headerName: "Zone", field: "Zone" },
  ];

  const handleExport = async () => {
    const data = await fetcRoBoData();
    if (!data || data.length === 0) {
      console.warn("No data to export");
      return;
    }

    const wb = XLSX.utils.book_new();
    const wsData = [
      columns.map((column) => column.headerName), // Header row
      ...data.map((row) =>
        columns.map((column) => {
          const value = row[column.field];
          return value || "";
        })
      ),
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "RoBo_Data");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `roBo_data_${dayjs().format("YYYYMMDD")}.xlsx`);
  };

  return (
    <>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link
          underline="hover"
          key="1"
          color="inherit"
          to="/settings"
          onClick={handleBack}
        >
          Admin Panel
        </Link>
        <Typography key="2" color="text.primary">
          RO/BO Master
        </Typography>
      </Breadcrumbs>

      <div className="p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold">RO/BO Master</h1>
          </div>
          <div>
            <Button
              onClick={() => setAddRoBoModalOpen(true)}
              variant="contained"
              color="success"
              startIcon={<AddIcon />}
              sx={{ mr: 1 }}
            >
              Add New RO/BO
            </Button>

            <Button
              onClick={() => handleExport()}
              variant="contained"
              color="secondary"
              startIcon={<Download />}
              sx={{ mr: 1 }}
            >
              Download
            </Button>
          </div>
        </div>

        <BranchFilter
          filters={filters}
          setFilters={setFilters}
          onApplyFilters={getRoBoData}
        />

        <RoBoTableComponent
          roBoList={roBoList}
          loading={loading}
          setLoading={setLoading}
          onRefresh={() => getRoBoData(filters)}
        />

        <RoBoModal
          open={addRoBoModalOpen}
          onClose={() => setAddRoBoModalOpen(false)}
          onRefresh={() => getRoBoData(filters)}
        />
      </div>
    </>
  );
};

export default RoBoComponent;
